/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Ai_Tools_Studio_Top_UpInputs */

const en_directory_ai_tools_studio_top_up = /** @type {(inputs: Directory_Ai_Tools_Studio_Top_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get credits`)
};

const zh_directory_ai_tools_studio_top_up = /** @type {(inputs: Directory_Ai_Tools_Studio_Top_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`购买积分`)
};

/**
* | output |
* | --- |
* | "Get credits" |
*
* @param {Directory_Ai_Tools_Studio_Top_UpInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_ai_tools_studio_top_up = /** @type {((inputs?: Directory_Ai_Tools_Studio_Top_UpInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Ai_Tools_Studio_Top_UpInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_ai_tools_studio_top_up(inputs)
	return zh_directory_ai_tools_studio_top_up(inputs)
});
export { directory_ai_tools_studio_top_up as "directory.ai_tools.studio.top_up" }